module.exports = __webpack_public_path__ + "img/logo-branca.ef7d6079.svg";